module.exports = __webpack_public_path__ + "images/buttons/btn-appstore.0c89bea1f934eadd07d8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/buttons/btn-appstore.png
// module id = E8gt
// module chunks = 24